import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { Head } from '../../components/Head';
import { Image } from '../../components/Image';
import { Info } from '../../components/Info';
import { StyledContainer, StyledContent } from './HelpModal.styled';

const HelpModal = () => {
	const activeModal = useObservable(rage.helpModal.getActiveModal());

	const containsImages = useMemo(
		() => (activeModal ? activeModal.imageIds.length > 0 : false),
		[activeModal],
	);

	return (
		<StyledContainer>
			<Head />
			<StyledContent $img={containsImages}>
				{containsImages && <Image ids={activeModal?.imageIds ?? []} />}
				<Info img={containsImages} />
			</StyledContent>
		</StyledContainer>
	);
};

export { HelpModal };
